import React, { useState, useEffect } from "react";
import FormInputStyle4 from "../../UIElements/FormInput";
import FormSelectStyle4 from "../../UIElements/FormSelect";
import CustomCheckbox from "../customCheckBox/customCheckBox";
import FormButtonStyle4 from "../../UIElements/FormButton";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { toast } from "react-toastify";
import getStateFromPincode from "../../Utils/stateMapperfnction";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setInternalLead } from "../../../../store/app/aaSlice";
import useAddLead from "../../hooks/addLeadtoCRM";
import useUserEvent from "../../../../hooks/setUserclickhook";

function PersonalDetailsForm({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  setMobileForOTP,
  formData,
  setFormData,
}) {
  const [gender, setGender] = useState("");
  const [name, setName] = useState("");
  const [maritalStatus, setmaritalStatus] = useState("");
  const [errors, setErrors] = useState({});
  const [dob, setDob] = useState(null);
  const [mobile, setMobile] = useState("");
  const [loan_purpose, setloan_purpose] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [pancard, setPan] = useState("");
  const [isPanValid, setIsPanValid] = useState(true);
  const [pincode, setPincode] = useState("");
  const [professionType, setprofessionType] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [pincodeValidation, setpincodeValidation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state.app.user);
  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const aaSlice = useSelector((state) => state?.aa);
  const InternalLeadId = aaSlice?.internalLeadId;
  const addLead = useAddLead();

  const { trackUserEvent } = useUserEvent();

  const handleMobileChange = (event) => {
    let value = event.target.value;

    // Remove any non-digit characters
    value = value.replace(/\D/g, "");

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Allow only if first digit is 6, 7, 8, or 9 (if length >= 1)
    if (value.length === 0 || /^[6-9]/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
      setMobileForOTP(value);

      // Validate: length must be exactly 10 and no digit repeats more than 8 times consecutively
      const hasInvalidRepetition = /(.)\1{8,}/.test(value); // matches any digit repeated 9 or more times

      setIsMobileValid(value.length === 10 && !hasInvalidRepetition);
    }
  };

  useEffect(() => {
    if (!formData) return;

    setloan_purpose(formData.loan_purpose || "");
    setmaritalStatus(formData.maritalStatus || "");
    setEmail(formData.email || "");
    setGender(formData.gender || "");
    setPan(formData.pancard || "");
    setPincode(formData.pincode || "");
    setprofessionType(formData.professionType || "");
    setDob(formData.dob || null);

    // Optional validation setters
  }, []);

  const handleDobChange = (e) => {
    const value = e.target.value;
    const selectedDate = new Date(value);
    const bufferDate = new Date(maxDate); // assuming maxDate is like '2025-09-16'
    const minDate = new Date("1950-01-01");

    const today = new Date();

    if (selectedDate < minDate) {
      setErrors((prev) => ({
        ...prev,
        dob: "Date cannot be less than 1st Jan 1950",
      }));
    } else if (selectedDate > today) {
      // If date is in the future, show error
      setErrors((prev) => ({
        ...prev,
        dob: "Date of birth cannot be in the future",
      }));
    } else if (selectedDate > bufferDate && selectedDate <= today) {
      setErrors((prev) => ({
        ...prev,
        dob: `You must be at least 18 years old`,
      }));
    } else {
      // Date is valid
      setErrors((prev) => {
        const { dob, ...rest } = prev;
        return rest;
      });
    }

    setDob(value);
  };

  const handleEmailChange = (event) => {
    const value = event.target.value.trim();

    setEmail(value);
    setFormData((prev) => ({
      ...prev,
      email: value,
    }));

    // Always validate live
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(value));
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPan(value);

    // Always validate live
    const isValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
    setIsPanValid(isValid && value.length === 10); // only invalid if length = 10 & pattern fails
  };

  const handlePincodeChange = async (value) => {
    value = value.replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setPincode(value); // always update input field

      // clear error if user is still typing
      if (errors.pincode) {
        setErrors((prev) => ({ ...prev, pincode: false }));
      }

      // Only validate when user has entered 6 digits
      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API using callApi instead of fetch
          const response = await callApi(
            `v1/util/${value}`, // backend route
            "get", // HTTP method
            {}, // body (not needed for GET)
            "core" // service key
          );

          if (!response.success) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          } else {
            setErrors((prev) => ({ ...prev, pincode: false }));
            setFormData((prev) => ({
              ...prev,
              city: response.city,
              state: getStateFromPincode(value),
            }));

            console.log("Valid Pincode, City:", response.city);
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, pincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };

  const handleProfessionChnage = (value) => {
    //console.log(value);
    setprofessionType(value);
    if (errors.professionType) {
      setErrors((prev) => ({ ...prev, professionType: false }));
    }
  };

  const handleMaritalStatus = (value) => {
    //console.log(value);
    setmaritalStatus(value);
    if (errors.maritalStatus) {
      setErrors((prev) => ({ ...prev, maritalStatus: false }));
    }
  };

  const handleNameChange = (e) => {
    let newName = e.target.value;

    // Remove any character that is not a letter or space
    newName = newName.replace(/[^A-Za-z\s]/g, "");

    // Replace multiple spaces with a single space
    newName = newName.replace(/\s+/g, " ");

    setName(newName);

    // Validate: name must have at least 2 characters after trimming
    setErrors((prev) => ({
      ...prev,
      name: newName.trim().length < 2,
    }));
  };

  //console.log("Personal formData:", formData);

  useEffect(() => {
    const allValid =
      gender &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
      (!errors.email || errors.email === false) &&
      /^\d{6}$/.test(pincode) &&
      (!errors.pincode || errors.pincode === false || pincodeValidation) &&
      professionType &&
      (!errors.professionType || errors.professionType === false) &&
      maritalStatus &&
      (!errors.maritalStatus || errors.maritalStatus === false) &&
      pancard &&
      (!errors.pan || errors.pan === false) &&
      isPanValid &&
      loan_purpose &&
      isConsentChecked &&
      dob &&
      (!errors.dob || errors.dob === false);

    setIsFormValid(allValid);
  }, [
    gender,
    email,
    loan_purpose,
    errors.email,
    dob,
    errors.dob,
    pincode,
    errors.pincode,
    maritalStatus,
    errors.maritalStatus,
    professionType,
    errors.professionType,
    pancard,
    errors.pan,
    isPanValid,
    isConsentChecked,
  ]);

  useEffect(() => {
    if (formData) {
      setGender(formData.gender || "");
      setmaritalStatus(formData.maritalStatus || "");
      setMobile(formData.mobile || "");
      setPan(formData.pancard || "");
      setEmail(formData.email || "");
      setPincode(formData.pincode || "");
      setprofessionType(formData.professionType || "");
      setDob(formData.dob || null);
      setIsConsentChecked(formData.mobiletncchecked || false);
      setloan_purpose(formData.loan_purpose || "");
      // setFormData((prev) => ({
      //   ...prev,
      // setIpAddress(ipAddress);
    }
  }, []);

  const handleConsentChange = async () => {
    setIsConsentChecked((prev) => {
      const newValue = !prev;
      //console.log("Old:", prev, "New:", newValue);
      return newValue;
    });
  };
  const handleValidateAndSendOtp = async () => {
    // Step 1: Validate form
    if (!handleValidation()) {
      return;
    }

    // Step 2: Check consent
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    try {
      setIsLoading(true);

      // Step 3: Call API to send OTP

      // Step 4: Handle API response

      //  affId ||

      // Step 5: Update form data only after OTP sent
      setFormData((prev) => ({
        ...prev,
        gender,
        pancard,
        email,
        pincode,
        professionType,
        loan_purpose,
        maritalStatus,
        mobile,
        dob,
        mobiletncchecked: true,
        mobiletnctime: new Date().toISOString(),
      }));

      const trackId = localStorage.getItem("track_id");

      const url = InternalLeadId
        ? `v1/lead/${InternalLeadId}/update-lead-new`
        : "v1/lead/dmi-lead";

      const res = await callApi(
        url,
        "post",
        {
          lead: {
            tracking_id: trackId,
            contact_phone: mobile,
            contact_email: email,
            dob: dob,
            gender: gender,
            pincode,
            city: formData.city,
            state: formData.state,
            pancard: pancard,
            profession_type: professionType,
            maritalStatus: maritalStatus,
            steps_completed: 2,
            alliance_id: "website-pl-ete-lead",
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source"),
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            ads_name: params.get("ads_name"),
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTMxNTQ2NDEwYjdkNTgzMDA3NjIyYmEiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wNFQwOTozOTowOC42NjhaIiwiaWF0IjoxNzY0ODQwNTU0fQ.ksMJv8yeMuVZvk6EtBuajtH1-CuCvtvFmv2X-1Ab71Y"
      );
      await callApi(
        `v1/lead/customer-check-e2e`,
        "post",
        {
          lead: {
            tracking_id: trackId,
            contact_phone: mobile,
            contact_email: email,
            dob: dob,
            gender: gender,
            pincode,
            city: formData.city,
            state: formData.state,
            pancard: pancard,
            profession_type: professionType,
            maritalStatus: maritalStatus,
            steps_completed: 2,
            alliance_id: "website-pl-ete-lead",
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source"),
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            ads_name: params.get("ads_name"),
          },
        },
        "core",
        user?.token ||
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTMxNTQ2NDEwYjdkNTgzMDA3NjIyYmEiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk5MjIxODcwMDUiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMi0wNFQwOTozOTowOC42NjhaIiwiaWF0IjoxNzY0ODQwNTU0fQ.ksMJv8yeMuVZvk6EtBuajtH1-CuCvtvFmv2X-1Ab71Y"
      );
      const finalLeadId = InternalLeadId || res?.data?.lead?._id;
      if (!InternalLeadId) {
        dispatch(setInternalLead(finalLeadId));
      }
      trackUserEvent(
        "personal-page-e2e",
        res?.data?.lead?._id || InternalLeadId
      );

      toast.success("OTP Sent Successfully");

      // Call useAddLead hook on successful submission
      if (finalLeadId) {
        try {
          await addLead({
            leadId: finalLeadId,
            lead_type: "live",
            priority: 3,
            stage: "Personal Details",
          });
        } catch (error) {
          console.error("Error adding lead to CRM:", error);
        }
      }

      setIsFormStarted(true);

      // Step 6: Move to OTP step
      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    //console.log("Consent checked updated:", isConsentChecked);
  }, [isConsentChecked]);

  const handleValidation = () => {
    setShowErrors(true);

    const newErrors = {};

    if (!gender) newErrors.gender = true;
    if (!dob) newErrors.dob = true;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = true;
      setIsEmailValid(false);
    }

    if (!pincode.match(/^\d{6}$/)) newErrors.pincode = true;

    if (!professionType) newErrors.professionType = true;
    if (!maritalStatus) newErrors.maritalStatus = true;

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pancard)) {
      newErrors.pancard = true;
      setIsPanValid(false);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const today = new Date();
  const year = today.getFullYear() - 18;
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const maxDate = `${year}-${month}-${day}`;

  return (
    <div>
      <div className="w-full  flex font-polysans -mt-3  justify-center items-center gap-2 text-[#1B1B1B] ">
        <div className="w-[44px] h-[1px] bg-[#B3B3B3]" />
        <p className="text-[18px] font-bold xs:text-[16px]">
          Personal information
        </p>

        <div className="w-[44px] h-[1px] bg-[#B3B3B3]" />
      </div>
      <p className="text-[12px] text-[#8B8B8B] xs:text-[12px] text-center mb-3">
        We will use your contact details to proceed further.
      </p>

      <div className="flex flex-wrap gap-2 mb-3  items-center justify-center">
        {/* Male Button */}
        <button
          className={`flex items-center justify-center w-[165px] xs:w-[150px] sm:w-[165px] h-[55px] sm:h-[55px] border-[1px] rounded-md text-base cursor-pointer font-atkinson transition-colors duration-200 ${
            gender.toLocaleLowerCase() === "Male".toLocaleLowerCase()
              ? "bg-neutral-900 text-green-400 border-neutral-900"
              : "bg-white text-black border-gray-400 hover:bg-gray-100"
          }`}
          onClick={() => setGender("Male")}
        >
          <div className="flex items-center gap-2">
            <img
              src={
                gender === "Male"
                  ? "/assets/img/Male_green.svg"
                  : "/assets/img/Male_black.svg"
              }
              alt="Male Icon"
              className="h-5"
            />
            <span>Male</span>
          </div>
        </button>

        {/* Female Button */}
        <button
          className={`flex items-center justify-center w-[165px] xs:w-[150px] sm:w-[165px] h-[55px] sm:h-[55px] border-[1px] rounded-md text-base cursor-pointer font-atkinson transition-colors duration-200 ${
            gender.toLocaleLowerCase() === "Female".toLocaleLowerCase()
              ? "bg-neutral-900 text-green-400 border-neutral-900"
              : "bg-white text-black border-gray-400 hover:bg-gray-100"
          }`}
          onClick={() => setGender("Female")}
        >
          <div className="flex items-center gap-2">
            <img
              src={
                gender === "Female"
                  ? "/assets/img/Female_green.svg"
                  : "/assets/img/Female_black.svg"
              }
              alt="Female Icon"
              className="h-5"
            />
            <span>Female</span>
          </div>
        </button>
      </div>

      {/* <FormInputStyle4
        label="Full Name as per Pan Card"
        value={name}
        maxlength={100}
        onChange={handleNameChange}
        isValid={!errors.name}
        errorMessage="Please enter a valid name with only one space between words"
      /> */}

      <FormInputStyle4
        type="date"
        label="Date of Birth"
        value={dob}
        min={"1950-01-01"}
        onChange={handleDobChange}
        isValid={!errors.dob}
        max={maxDate}
        errorMessage={errors.dob ? errors.dob : "Date of birth is required"}
      />
      <FormInputStyle4
        label="Home Pin Code"
        value={pincode}
        onChange={(e) => handlePincodeChange(e.target.value)}
        onBlur={() => {
          if (!/^\d{6}$/.test(pincode) || errors.pincode) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          }
        }}
        isValid={!errors.pincode}
        errorMessage="Enter a valid 6-digit PIN"
        tick={pincode.length === 6 && !errors.pincode}
        loading={pincodeValidation}
      />
      <FormInputStyle4
        type="text"
        name="pancard"
        isValid={isPanValid}
        id="pancard"
        minLength="10"
        maxLength="10"
        value={pancard}
        onChange={handlePanChange}
        required
        label={"PAN Card Number"}
        inputMode="text"
        errorMessage={"Please enter a valid PAN Number"}
      />
      {/* <FormInputStyle4
        label="Mobile Number"
        value={mobile}
        isValid={isMobileValid}
        minLength="10"
        maxLength="10"
        pattern="[0-9]{10}"
        inputMode="numeric"
        onChange={handleMobileChange}
        errorMessage="Mobile Number is required"
      /> */}
      <FormInputStyle4
        label="Personal Email Address"
        value={email}
        maxlength={100}
        onChange={handleEmailChange}
        isValid={isEmailValid}
        errorMessage="Enter a valid email"
      />
      <FormSelectStyle4
        label="Marital Status"
        value={maritalStatus}
        onChange={handleMaritalStatus}
        onBlur={() => {
          if (!maritalStatus) {
            setErrors((prev) => ({ ...prev, maritalStatus: true }));
          }
        }}
        options={[
          { label: "Single", value: "Single" },
          { label: "Married", value: "Married" },
          { label: "Divorced", value: "Divorced" },
        ]}
        isValid={!errors.maritalStatus}
        errorMessage="Please select Marital Status"
      />
      <FormSelectStyle4
        label="Purpose of Loan"
        value={loan_purpose}
        onChange={(e) => setloan_purpose(e)}
        options={[
          { label: "Wedding/Other Events", value: "wedding/other events" },
          { label: "Medical Expenses", value: "medical expenses" },
          { label: "Home Renovation", value: "home renovation" },
          { label: "Travel Expenses", value: "travel expenses" },
          { label: "Education Expenses", value: "education expenses" },
          { label: "Business Expenses", value: "business expenses" },
          { label: "Electronics Purchase", value: "electronics purchase" },
          { label: "Jewellery Purchase", value: "jewellery purchase" },
          {
            label: "Stock Market Trading/Investment",
            value: "stock market trading/investment",
          },
          {
            label: "Betting/Gambling/Speculative purposes",
            value: "betting/gambling/speculative purposes",
          },
          { label: "Other Personal Use", value: "other personal use" },
        ]}
        isValid={!errors.loan_purpose}
        errorMessage="Please select purpose"
      />

      {/* Employment Type */}
      <div className="form-input-wrapper">
        <p className="text-[14px] font-atkinson text-[#1B1B1B] mb-2">
          Employment Type
        </p>

        <div className="flex gap-3">
          {/* Salaried */}
          <button
            type="button"
            onClick={() => handleProfessionChnage("salaried")}
            className={`flex items-center gap-2 px-4 py-3 border rounded-md w-[160px] transition-all
        ${
          professionType === "salaried"
            ? "border-black bg-[#F5F5F5]"
            : "border-gray-300 bg-white"
        }
      `}
          >
            <span
              className={`w-4 h-4 rounded-full border flex items-center justify-center
          ${professionType === "salaried" ? "border-black" : "border-gray-400"}
        `}
            >
              {professionType === "salaried" && (
                <span className="w-2 h-2 rounded-full bg-black" />
              )}
            </span>
            <span className="text-sm">Salaried</span>
          </button>

          {/* Self-Employed */}
          <button
            type="button"
            onClick={() => handleProfessionChnage("self_employed")}
            className={`flex items-center gap-2 px-4 py-3 border rounded-md w-[160px] transition-all
        ${
          professionType === "self_employed"
            ? "border-black bg-[#F5F5F5]"
            : "border-gray-300 bg-white"
        }
      `}
          >
            <span
              className={`w-4 h-4 rounded-full border flex items-center justify-center
          ${
            professionType === "self_employed"
              ? "border-black"
              : "border-gray-400"
          }
        `}
            >
              {professionType === "self_employed" && (
                <span className="w-2 h-2 rounded-full bg-black" />
              )}
            </span>
            <span className="text-sm">Self-Employed</span>
          </button>
        </div>

        {showErrors && errors.professionType && (
          <p className="text-red-500 text-xs mt-1">
            Please select employment type
          </p>
        )}
      </div>

      <div className="flex mx-auto w-[85%] gap-2">
        <CustomCheckbox
          checked={isConsentChecked}
          setchecked={setIsConsentChecked}
        />
        <p className="text-[7px] font-atkinson text-[#B3B3B3] leading-[9px]">
          I agree that the loan applied for from{" "}
          <a
            href="lending-partners"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0077FF] text-[9px]"
          >
            Lending Partners{" "}
          </a>{" "}
          will be governed by the
          <a
            href="privacy-policy"
            target="_blank"
            className="text-[#0077FF] text-[9px]"
          >
            Terms &amp; Conditions
          </a>{" "}
          . I declare that my gross household income is greater than Rs. 25,000
          per month. To process my application, I give my explicit consent to
          DigitMoney &amp; its Lending Partners to obtain my credit report(s)
          from credit bureaus, to fetch required information for KYC from
          approved agencies including UIDAI, to reach out to me with
          personalized offers on products &amp; services through SMS, WhatsApp,
          RCS, Email and telephonic calls/bots and this consent will override
          any registration for DND and/or NDNC.
        </p>
      </div>

      <FormButtonStyle4
        className="mt-3"
        text="Continue"
        disabled={!isFormValid || isLoading || pincodeValidation}
        isLoading={isLoading}
        onClick={handleValidateAndSendOtp}
      />
    </div>
  );
}

export default PersonalDetailsForm;
